import { render, staticRenderFns } from "./BaseEdit.vue?vue&type=template&id=713b0f4c&scoped=true"
import script from "./BaseEdit.vue?vue&type=script&lang=js"
export * from "./BaseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b0f4c",
  null
  
)

export default component.exports